import * as Sentry from '@sentry/react';
import {
  VITE_CLOUD_API,
  VITE_ENVIRONMENT,
  VITE_GATEWAY_API,
  VITE_LEGACY_API,
  VITE_MARKET_API,
  VITE_SENTRY_DSN,
} from '../envs';
import { parseToken } from '@oai-frontend-monorepo/utils';

console.log('Running environment', VITE_ENVIRONMENT);

const GATEWAY_API = VITE_GATEWAY_API;

// // Creating the regex pattern
const legacyAPI = new RegExp(`^${VITE_LEGACY_API}/?.*$`);
const gatewayAPI = new RegExp(`^${GATEWAY_API}/?.*$`);
const REACT_APP_MARKET_API = VITE_MARKET_API;
const marketAPI = new RegExp(`^${REACT_APP_MARKET_API}/?.*$`);
const cloudApi = new RegExp(`^${VITE_CLOUD_API}/?.*$`);
const toolsApi = new RegExp(`^https://tools.options.ai/?.*$`);

// const companyAPI = new RegExp(`^${REACT_APP_COMPANY_API}/?.*$`);
// const graphQLAPI = new RegExp(`^${import.meta.env.REACT_APP_GRAPHQL_HOST}/?$`);

// todo: ensure correct envs
if (VITE_ENVIRONMENT !== 'local') {
  Sentry.init({
    dsn: VITE_SENTRY_DSN,
    environment: VITE_ENVIRONMENT,
    release: 'tradier-pre-release',
    _experiments: {
      // profilesSampleRate is relative to tracesSampleRate.
      // Here, we'll capture profiles for 100% of transactions.
      profilesSampleRate: 1.0,
    },
    tracesSampleRate: 1.0,
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 1.0,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
        maxReplayDuration: 60 * 1000 * 60,

        networkDetailAllowUrls: [
          legacyAPI,
          gatewayAPI,
          marketAPI,
          cloudApi,
          toolsApi,
          // companyAPI,
          // graphQLAPI,
          // 'https://production-gateway-api.herokuapp.com/moves',
        ],
        networkCaptureBodies: true,
      }),
    ],
  });
}

export const setSentryUser = (token?: string) => {
  const parsed = parseToken(token);

  if (!parsed) {
    return;
  }

  Sentry.setUser({
    id: parsed.oai,
    username: parsed.oai,
    groups: parsed.groups,
    token: token,
  });
};
